__turbopack_context__.v({
  "className": "geistsans_47a3c9f1-module__2HyNMa__className",
  "variable": "geistsans_47a3c9f1-module__2HyNMa__variable",
});
